// extracted by mini-css-extract-plugin
module.exports = {"social":"footer_social__2yNzR","email":"footer_email__3OHPe","footerFont":"footer_footerFont__3W1I7"};